import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Rızalarınız',
  empty: 'Sizi ilgilendiren bir rıza talebi yok.',
  collectiveNote:
    'Departmanda yürürlükte olan bir toplu kayıt var; bu geçerli olduğu sürece kişisel yanıtınızın etkisi yoktur.',
  table: {
    department: 'Departman',
    status: 'Durum',
    basis: 'Yürürlükteki dayanak',
  },
  status: {
    pending: 'Yanıtınız bekleniyor',
    granted: 'Verildi',
    denied: 'Reddedildi',
  },
  basis: {
    personal: 'Kişisel',
    collective: 'Toplu',
  },
  actions: {
    grant: 'Ver',
    deny: 'Reddet',
    withdraw: 'Geri çek',
  },
};
